export const searchTextSpan = { backgroundColor: '#efa24a', color: 'white',marginLeft:'10px',cursor:'auto' }
export const searchTextSpan2 = { backgroundColor: '#efa24a', color: 'white',marginLeft:'0px',cursor:'auto' }

export const searchTextBtn = () => ({ color:'white !important', cursor: 'pointer', })